// extracted by mini-css-extract-plugin
export default {"wrapper":"DiscountProgressBar_wrapper__9wKOr"};